(function () {
    'use strict';

    angular.module('edit')
        .service('editService', ['$http', 'editConfigService', 'dialogService', '$q', function ($http, editConfigService, dialogService, $q) {

            return {
                obj: null,
                save: function (keliuPrieziurosObjektas) {
                    return $http.put(editConfigService.SaveObject, keliuPrieziurosObjektas);
                    },
                updateStatus: function (keliuPrieziurosObjektas) {
                    return $http.put(editConfigService.UpdateStatus + keliuPrieziurosObjektas.id);
                },
                changeStatus: function (status) {
                    return $http.post(editConfigService.changeStatus, status);
                },
                getHistory: function (id) {
                    return $http.get(editConfigService.getHistory, {params:{id: id}});
                },
                resolveRoadDivisions: function (kpo) {
                    var params = {roadId: kpo.kelioId, kmFrom: kpo.kmNuo, kmTo: kpo.kmIki}
                    return $http.get(editConfigService.roadDivisions, {params: params});
                },
                getMyLocation: function (callback) {
                    if(!navigator.geolocation) {
                        dialogService.error('Jūsų naršyklė nepalaiko buvimo vietos nustatymo funkcijos.');
                        return;
                    }
                    var options = {
                        enableHighAccuracy: true,
                        timeout: 120000,
                        maximumAge: 0
                    };
                    var location = null;
                    var watchId = null;
                    var progress = $q.defer();
                    var success = function(pos) {
                        if(location == null || location.coords.accuracy > pos.coords.accuracy) {
                            progress.notify('Bandome nustatyti Jūsų buvimo vietą... Tikslumas '+(pos.coords.accuracy | 0)+' m');
                            location = pos;
                        }
                    };
                    var error = function() {
                        progress.reject('Įvyko klaida bandant nustatyti Jūsų buvimo vietą');
                    };
                    var timeoutId;
                    var args = {
                        progress: function(progress) {
                            args.$scope.ngDialogData.text = progress;
                            args['ready'] = true;
                        },
                        useCoords: function() {
                            progress.resolve();
                            args.$scope.closeThisDialog();
                            navigator.geolocation.clearWatch(watchId);
                            callback(location);
                            clearTimeout(timeoutId);
                        }
                    };
                    dialogService.customBlockingDialog('layout/dialogs/geolocationDialog.html', args, progress.promise, null, 'Bandome nustatyti Jūsų buvimo vietą...');
                    watchId = navigator.geolocation.watchPosition(success, error, options);
                    timeoutId = setTimeout(function() {
                        if(location == null) {
                            error();
                        } else {
                            args.useCoords();
                        }
                        navigator.geolocation.clearWatch(watchId);
                    }, 120000);
                },
                transformCoordinates: function (position) {
                    var data = {
                        inSR: 4326,
                        outSR: 3346,
                        geometries: {
                            geometryType: 'esriGeometryPoint',
                            geometries: [
                                {
                                    x: position.coords.longitude,
                                    y: position.coords.latitude
                                }
                            ]
                        },
                        transformation: '',
                        transformForward: false,
                        vertical: false,
                        f: 'pjson',
                        callback: 'JSON_CALLBACK'
                    };
                    return $http.jsonp(editConfigService.JsonTransformCoords, { params: data });
                },
                resolveRoadByNumber: function (number) {
                    return $http.get(editConfigService.roadSearch + number);
                },
                resolveRoad: function (x, y) {
                    return $http.jsonp(editConfigService.JsonResolveRoad + x + '&y=' + y + '&tolerance=10000&rastizenkla=&f=pjson&callback=JSON_CALLBACK');
                },
                resolveCoordinates: function (pRoadNr, pKm) {
                    return $http.jsonp(editConfigService.JsonResolveCoords + pRoadNr + '&km=' + pKm + '&kryptis=AB&f=pjson&callback=JSON_CALLBACK');
                },
                remove: function (id) {
                    return $http.delete(editConfigService.DeleteObject + id);
                },
                resolveAddress: function (x, y) {
                    return $http.get(editConfigService.GetAddress + x + '&y=' + y);
                },
                getWithSelected: function (idArray, itemsArray) {
                    var result = angular.copy(itemsArray);
                    angular.forEach(idArray, function (id) {
                        angular.forEach(result, function (item) {
                            if (item.id === id) {
                                item.selected = true;
                            }
                        });
                    });
                    return result;
                },
                getDatepickerOptions: function () {
                    return {
                        monthsFull: ['Sausis', 'Vasaris', 'Kovas', 'Balandis', 'Gegužė', 'Birželis', 'Liepa', 'Rugpjūtis', 'Rugsėjis', 'Spalis', 'Lapkritis', 'Gruodis'],
                        monthsShort: ['Sau', 'Vas', 'Kov', 'Bal', 'Geg', 'Bir', 'Lie', 'Rgp', 'Rgs', 'Spa', 'Lap', 'Gru'],
                        weekdaysFull: ['Sekmadienis', 'Pirmadienis', 'Antradienis', 'Trečiadienis', 'Ketvirtadienis', 'Penktadienis', 'Šeštadienis'],
                        weekdaysShort: ['Sek', 'Pir', 'Ant', 'Tre', 'Ket', 'Pen', 'Šeš'],
                        today: 'Šiandien',
                        clear: 'Išvalyti',
                        close: 'Uždaryti',
                        labelMonthNext: 'Sekantis mėnuo',
                        labelMonthPrev: 'Praeitas mėnuo',
                        labelMonthSelect: 'Pasirinkite mėnesį',
                        labelYearSelect: 'Pasirinkite metus',
                        format: 'yyyy-mm-dd',
                        firstDay: 1
                    };
                },
                getMultiselectTranslations: function () {
                    return {
                        selectAll: 'Pažymėti visus',
                        selectNone: 'Atšaukti',
                        reset: 'Atšaukti visus',
                        search: 'Norėdami ieškoti rašykite...',
                        nothingSelected: 'Niekas nepasirinkta'
                    };
                },
                distanceBetweenPoints: function (x1, y1, x2, y2) {
                    return Math.sqrt(Math.pow((x1 - x2), 2) + Math.pow((y1 - y2), 2));
                },
                round: function (number, decimalPlaces) {
                    return Math.round(number * Math.pow(10, decimalPlaces)) / Math.pow(10, decimalPlaces);
                },
                coordsInExtent: function (x, y) {
                    return x > 300000 && x < 690000 && y > 5970000 && y < 6260000;
                },
                getObjectById: function(id) {
                    return $http.get(editConfigService.getObjectById + id);
                }
            };
        }]);
})();
